module.exports = __webpack_public_path__ + "static/media/goldfinch.0fa50edc.svg";